import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateContentNestedSortMutation } from "../graphql/mutations";
import type {
  UpdateContentNestedSortMutationType,
  UpdateContentNestedSortMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateContentNestedSortMutation = (
  options?: MutationHookOptions<
    UpdateContentNestedSortMutationType,
    UpdateContentNestedSortMutationVariablesType
  >
) => {
  return useMutation<
    UpdateContentNestedSortMutationType,
    UpdateContentNestedSortMutationVariablesType
  >(UpdateContentNestedSortMutation, options);
};
